import { render, staticRenderFns } from "./SenkronAlanFrekansMatrisi.vue?vue&type=template&id=892a9210&scoped=true"
import script from "./SenkronAlanFrekansMatrisi.vue?vue&type=script&lang=ts"
export * from "./SenkronAlanFrekansMatrisi.vue?vue&type=script&lang=ts"
import style0 from "./SenkronAlanFrekansMatrisi.vue?vue&type=style&index=0&id=892a9210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892a9210",
  null
  
)

export default component.exports